import { Menu as AntMenu, message, Dropdown } from "antd";
import Sider from "antd/es/layout/Sider";
import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import logo from "../../Assets/Images/Logo.png";
import logoDark from "../../Assets/icons/Sidebaricon/Logo Dark.svg";

import logoutIcon from "../../Assets/icons/Sidebaricon/log out.svg";
import settingIcon from "../../Assets/icons/Sidebaricon/Settings.svg";

import dashboardicon from "../../Assets/icons/Sidebaricon/Dashboard.svg";
import dashboardiconDark from "../../Assets/icons/Sidebaricon/Dashboard DarkMode.svg";

import mileageicon from "../../Assets/icons/Sidebaricon/Mileage.svg";
import mileageicondark from "../../Assets/icons/Sidebaricon/Mileage Dark.svg";
import fuelicon from "../../Assets/icons/Sidebaricon/Fuel.svg";
import fueliconDark from "../../Assets/icons/Sidebaricon/Fuel Dark.svg";

import fueleffiency from "../../Assets/icons/Sidebaricon/Fuel Efficiency.svg";
import fueleffiencyDark from "../../Assets/icons/Sidebaricon/Fuel Efficiency Dark.svg";

import idleicon from "../../Assets/icons/Sidebaricon/Idle.svg";
import idleiconDark from "../../Assets/icons/Sidebaricon/Idle Dark.svg";
import DEicon from "../../Assets/icons/Sidebaricon/Decision Engine.svg";
import DEiconDark from "../../Assets/icons/Sidebaricon/dec_engine_dark.svg";
import sensoricon from "../../Assets/icons/Sidebaricon/Sensor.svg";
import sensoriconDark from "../../Assets/icons/Sidebaricon/Sensor Dark.svg";
import SRicon from "../../Assets/icons/Sidebaricon/Servicing & Reminder.svg";
import SRiconDark from "../../Assets/icons/Sidebaricon/Servicing & Reminder Dark.svg";
import analysisicon from "../../Assets/icons/Sidebaricon/More Analysis.svg";
import analysisiconDark from "../../Assets/icons/Sidebaricon/More Analysis Dark.svg";
import dropDown from "../../Assets/icons/Sidebaricon/double Arrow.svg";
import userIcon from "../../Assets/Images/Logout.png";

import activeDashboardicon from "../../Assets/icons/Sidebaricon/Active Dashboard.svg";
import activeMileageIcon from "../../Assets/icons/Sidebaricon/Active Mileage.svg";
import activeFuelIcon from "../../Assets/icons/Sidebaricon/Active Fuel.svg";

import activeFuelEfficiencyIcon from "../../Assets/icons/Sidebaricon/Active Fuel Efficiency.svg";
import activeIdleIcon from "../../Assets/icons/Sidebaricon/Active Idle.svg";
import activeDEIcon from "../../Assets/icons/Sidebaricon/Active Decision Engine.svg";
import activeSensorIcon from "../../Assets/icons/Sidebaricon/Active Sensor.svg";
import activeSRIcon from "../../Assets/icons/Sidebaricon/Active Servicing & Reminder.svg";
import activeAnalysisIcon from "../../Assets/icons/Sidebaricon/Active More Analysis.svg";

import "./style.css";
import { UserContext } from "../../App";
import { handleLogout } from "../../Utils/UpdateUsersState";
import { UserOutlined } from "@ant-design/icons";
import { ThemeContext } from "../../Contexts/ThemeProvider";

const Sidebar = ({
  breakpoint = null,
  setPage,
  setMode,
  collapsed,
  setCollapsed,
  setFlag,
}) => {
  const { isDarkMode } = useContext(ThemeContext);

  // No one delete this comment, I myself will delete this after 2 weeks
  // useEffect(() => {
  //   const observer = new MutationObserver(() => {
  //     setIsDarkMode(document.body.classList.contains("dark-mode"));
  //   });

  //   observer.observe(document.body, {
  //     attributes: true,
  //     attributeFilter: ["class"],
  //   });

  //   return () => observer.disconnect();
  // }, []);

  const path = useLocation();
  const locationPath = path.pathname;
  const { userPages } = useContext(UserContext);
  const {
    userData,
    setUserData,
    setUserToken,
    setUserPages,
    setUserApiKeyStatus,
  } = useContext(UserContext);
  const navigate = useNavigate();
  const [selectedId, setSelectedId] = useState("1");

  const onLogout = () => {
    setFlag(false);
    handleLogout(setUserData, setUserToken, setUserPages, setUserApiKeyStatus);
    navigate("/login");
    message.success("Logged Out");
  };

  const onSettings = () => {
    navigate("/settings");
  };

  const userMenu = (
    <AntMenu className="custom-menu-dropdown">
      <AntMenu.Item key="settings" onClick={onSettings}>
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="10"
              cy="10"
              r="2.5"
              stroke="#3F3F46"
              stroke-width="1.2"
            />
            <path
              d="M11.471 1.79288C11.1648 1.66602 10.7765 1.66602 9.99991 1.66602C9.22334 1.66602 8.83505 1.66602 8.52877 1.79288C8.12039 1.96204 7.79593 2.2865 7.62678 2.69488C7.54956 2.8813 7.51934 3.0981 7.50751 3.41434C7.49013 3.87908 7.2518 4.30926 6.84904 4.54179C6.44628 4.77432 5.95458 4.76563 5.54341 4.54831C5.26362 4.40043 5.06076 4.3182 4.8607 4.29186C4.42245 4.23417 3.97924 4.35293 3.62855 4.62202C3.36554 4.82383 3.1714 5.1601 2.78311 5.83263C2.39483 6.50515 2.20069 6.84142 2.15741 7.1701C2.09972 7.60835 2.21848 8.05157 2.48757 8.40225C2.61039 8.56231 2.783 8.69687 3.05091 8.8652C3.44475 9.11267 3.69816 9.53423 3.69813 9.99937C3.69811 10.4645 3.44471 10.886 3.05091 11.1334C2.78296 11.3017 2.61032 11.4363 2.48748 11.5964C2.21839 11.9471 2.09964 12.3903 2.15733 12.8285C2.2006 13.1572 2.39475 13.4935 2.78303 14.166C3.17132 14.8385 3.36546 15.1748 3.62847 15.3766C3.97915 15.6457 4.42237 15.7645 4.86062 15.7068C5.06066 15.6804 5.26352 15.5982 5.54328 15.4504C5.95448 15.233 6.44622 15.2243 6.849 15.4569C7.25178 15.6894 7.49013 16.1196 7.50751 16.5844C7.51934 16.9006 7.54956 17.1174 7.62678 17.3038C7.79593 17.7122 8.12039 18.0367 8.52877 18.2058C8.83505 18.3327 9.22334 18.3327 9.99991 18.3327C10.7765 18.3327 11.1648 18.3327 11.471 18.2058C11.8794 18.0367 12.2039 17.7122 12.373 17.3038C12.4503 17.1174 12.4805 16.9006 12.4923 16.5843C12.5097 16.1196 12.748 15.6894 13.1507 15.4569C13.5535 15.2243 14.0453 15.233 14.4565 15.4503C14.7362 15.5982 14.9391 15.6804 15.1391 15.7067C15.5774 15.7644 16.0206 15.6457 16.3713 15.3766C16.6343 15.1748 16.8284 14.8385 17.2167 14.166C17.605 13.4934 17.7991 13.1572 17.8424 12.8285C17.9001 12.3902 17.7813 11.947 17.5123 11.5963C17.3894 11.4363 17.2168 11.3017 16.9489 11.1334C16.555 10.8859 16.3017 10.4644 16.3017 9.99927C16.3017 9.53422 16.5551 9.11275 16.9489 8.86534C17.2168 8.69697 17.3895 8.5624 17.5123 8.40231C17.7814 8.05162 17.9002 7.60841 17.8425 7.17016C17.7992 6.84148 17.6051 6.50521 17.2168 5.83268C16.8285 5.16015 16.6344 4.82389 16.3713 4.62207C16.0207 4.35298 15.5774 4.23422 15.1392 4.29192C14.9392 4.31826 14.7363 4.40048 14.4565 4.54835C14.0453 4.76568 13.5536 4.77436 13.1508 4.54182C12.748 4.30927 12.5097 3.87907 12.4923 3.4143C12.4805 3.09808 12.4503 2.88129 12.373 2.69488C12.2039 2.2865 11.8794 1.96204 11.471 1.79288Z"
              stroke="#3F3F46"
              stroke-width="1.2"
            />
          </svg>
          Settings
        </div>
      </AntMenu.Item>
      <AntMenu.Item key="logout" onClick={onLogout}>
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              opacity="0.5"
              d="M10 16.6673C6.3181 16.6673 3.33333 13.6825 3.33333 10.0007C3.33333 6.31875 6.3181 3.33398 10 3.33398"
              stroke="#3F3F46"
              stroke-width="1.5"
              stroke-linecap="round"
            />
            <path
              d="M8.33341 10H16.6667M16.6667 10L14.1667 7.5M16.6667 10L14.1667 12.5"
              stroke="#3F3F46"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          Logout
        </div>
      </AntMenu.Item>
    </AntMenu>
  );

  const items = [
    {
      type: "group",
      label: "Overview",
      children: [
        userPages?.includes("dashboard") && {
          key: "1",
          label: (
            <Link to="/dashboard" className="custom-menu-link">
              <img
                src={
                  selectedId === "1"
                    ? activeDashboardicon
                    : isDarkMode
                    ? dashboardiconDark
                    : dashboardicon
                }
                alt="Dashboard Icon"
              />
              <span className="menu-item-label">Dashboard</span>
            </Link>
          ),
        },
      ].filter(Boolean),
    },
    {
      type: "group",
      label: "Performance Metrics",

      children: [
        userPages?.includes("mileage") && {
          key: "2",
          label: (
            <Link to="/mileage" className="custom-menu-link">
              <img
                src={
                  selectedId === "2"
                    ? activeMileageIcon
                    : isDarkMode
                    ? mileageicondark
                    : mileageicon
                }
                alt="Mileage Icon"
              />
              <span className="menu-item-label">Mileage</span>
            </Link>
          ),
        },
        userPages?.includes("fuel") && {
          key: "3",
          label: (
            <Link to="/fuel" className="custom-menu-link">
              <img
                src={
                  selectedId === "3"
                    ? activeFuelIcon
                    : isDarkMode
                    ? fueliconDark
                    : fuelicon
                }
                alt="Fuel Icon"
              />
              <span className="menu-item-label">Fuel</span>
            </Link>
          ),
        },
        userPages?.includes("fuel_efficiency") && {
          key: "5",
          label: (
            <Link to="/fuel-efficiency" className="custom-menu-link">
              <img
                src={
                  selectedId === "5"
                    ? activeFuelEfficiencyIcon
                    : isDarkMode
                    ? fueleffiencyDark
                    : fueleffiency
                }
                alt="Fueleffiency Icon"
              />
              <span className="menu-item-label">Fuel Efficiency</span>
            </Link>
          ),
        },
        userPages?.includes("idle") && {
          key: "4",
          label: (
            <Link to="/idle" className="custom-menu-link">
              <img
                src={
                  selectedId === "4"
                    ? activeIdleIcon
                    : isDarkMode
                    ? idleiconDark
                    : idleicon
                }
                alt="Idle Icon"
              />
              <span className="menu-item-label">Idle</span>
            </Link>
          ),
        },
        userPages?.includes("decision_engine") && {
          key: "8",
          label: (
            <Link to="/decision-engine" className="custom-menu-link">
              <img
                src={
                  selectedId === "8"
                    ? activeDEIcon
                    : isDarkMode
                    ? DEiconDark
                    : DEicon
                }
                alt="DecisionEngineIcon"
              />
              <span className="menu-item-label">Decision Engine</span>
            </Link>
          ),
        },
      ].filter(Boolean),
    },
    {
      type: "group",
      label: "System Montioring",
      children: [
        userPages?.includes("sensor") && {
          key: "6",
          label: (
            <Link to="/sensor" className="custom-menu-link">
              <img
                src={
                  selectedId === "6"
                    ? activeSensorIcon
                    : isDarkMode
                    ? sensoriconDark
                    : sensoricon
                }
                alt="Sensor Icon"
              />
              <span className="menu-item-label">Sensor</span>
            </Link>
          ),
        },
      ].filter(Boolean),
    },
    {
      type: "group",
      label: "Maintenance",
      children: [
        userPages?.includes("servicing_reminder") && {
          key: "7",
          label: (
            <Link to="/servicing-reminder" className="custom-menu-link">
              <img
                src={
                  selectedId === "7"
                    ? activeSRIcon
                    : isDarkMode
                    ? SRiconDark
                    : SRicon
                }
                alt="SR Icon"
              />
              <span className="menu-item-label">Servicing & Reminder</span>
            </Link>
          ),
        },
        userPages?.includes("more_analysis") && {
          key: "9",
          label: (
            <Link to="/more-analysis" className="custom-menu-link">
              <img
                src={
                  selectedId === "9"
                    ? activeAnalysisIcon
                    : isDarkMode
                    ? analysisiconDark
                    : analysisicon
                }
                alt="Analysis Icon"
              />
              <span className="menu-item-label">More Analysis</span>
            </Link>
          ),
        },
      ].filter(Boolean),
    },
  ];

  useEffect(() => {
    if (locationPath.includes("/dashboard")) {
      setSelectedId("1");
    } else if (locationPath.includes("/mileage")) {
      setSelectedId("2");
    } else if (locationPath.includes("/fuel-efficiency")) {
      setSelectedId("5");
    } else if (locationPath.includes("/fuel")) {
      setSelectedId("3");
    } else if (locationPath.includes("/idle")) {
      setSelectedId("4");
    } else if (locationPath.includes("/sensor")) {
      setSelectedId("6");
    } else if (locationPath.includes("/servicing-reminder")) {
      setSelectedId("7");
    } else if (locationPath.includes("/decision-engine")) {
      setSelectedId("8");
    } else if (locationPath.includes("/more-analysis")) {
      setSelectedId("9");
    }
  }, [locationPath]);

  return (
    <Sider
      className="sidebar"
      width={220}
      theme="light"
      breakpoint={breakpoint}
      collapsed={collapsed}
      collapsedWidth="0"
      style={{ height: "100vh", position: "fixed" }}
    >
      <div className="logo-container">
        <img
          src={isDarkMode ? logoDark : logo}
          alt="logo"
          className="login-logo"
        />
      </div>

      <div
        style={{
          height: "90vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <AntMenu
          defaultSelectedKeys={["1"]}
          selectedKeys={[selectedId]}
          mode="inline"
          theme="light"
          items={items}
        />

        <Dropdown
          overlay={userMenu}
          placement="topCenter"
          trigger={["click"]}
          getPopupContainer={(triggerNode) => triggerNode.parentNode}
        >
          <div className="logout-div" style={{ cursor: "pointer" }}>
            <div className="logout-user">
              <div className="compact-avatar">
                {userData?.profile_picture ? (
                  <img
                    className="profile-pic"
                    src={userData?.profile_picture}
                    alt="user-icon"
                  />
                ) : (
                  <UserOutlined className="profile-pic" />
                )}
              </div>
              <div className="logout-user-details">
                <span className="role" title={userData?.role || "User"}>
                  {userData?.role || "User"}
                </span>
                <span
                  className="email"
                  title={userData?.email || "m@example.com"}
                >
                  {userData?.email || "m@example.com"}
                </span>
              </div>
            </div>
            <div className="logout-icon">
              <img src={dropDown} alt="CTA Icon" />
            </div>
          </div>
        </Dropdown>
      </div>
    </Sider>
  );
};

export default Sidebar;
